import { Component, Input, OnInit } from "@angular/core";
import { FormControllerService } from "../../../services/form-controller/form-controller.service";
import { FormioControllerService } from "../../../services/form-controller/formio-controller.service";
import { TagControllerService } from "../../../services/form-controller/tag-controller.service";
import { FormioBase } from "../../../models/formio/formiobase";
import { DataMappingHelpers } from "../../../models/data-mapping-helpers";
import { ClassificationType } from "../../../models/classification-type";
import { FieldGroup } from "../../../models/field-group";
import { FormField } from "../../../models/form-field";
import { ServiceField } from "../../../models/service-field";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../pages/base-error";
import FormUtils from "../../utils/form-utils.component";
import * as _ from "lodash";

@Component({
  selector: "sfl",
  templateUrl: "./sfl.component.html",
  providers: [FormControllerService, TagControllerService, FormioControllerService],
})
export class SflComponent extends BaseError implements OnInit {

  @Input() public showCopy: boolean = false;
  @Input() public showMoustaches: boolean = true;
  @Input() public showFields: boolean = true;
  @Input() public showCatalogs: boolean = false;
  @Input() public showTags: boolean = true;
  @Input() public serviceId: string;

  public allFields: any[] = [];
  public fields: any[] = [];
  public allCatalogs: any[] = [];
  public allTags: any[] = [];

  public searchFields: string = "";
  public searchCatalogs: string = "";
  public searchTags: string = "";

  public loadingTags: boolean = true;
  public loadingFields: boolean = true;
  public loadingCatalogs: boolean = true;

  public filterText: any;

  public searchStringFormatted: string = "";

  public moustaches: any[] = [
    "listing-value",
    "company-name",
    "rejection-reasons",
    "uploaded-documents",
    "requested-registrations",
    "userid",
    "username",
    // "userfullname",
    "applicantusername",
    "applicantuserid",
    "applicantfullname",
    "applicant-email",
    "applicant-phone",
    "starterEmail",
  ];

  constructor(
    private formControllerService: FormControllerService,
    public translate: TranslateService,
    public toastr: ToastrService,
    private formioController: FormioControllerService,
    public tagControllerService: TagControllerService,
  ) {
    super(toastr);
  }

  public ngOnInit(): void {
    if (this.showFields) {
      this.loadAllFields();
    }
    if (this.showTags) {
      this.loadAllTags();
    }
    if (this.showCatalogs) {
      this.loadCatalogs();
    }
  }

  public loadCatalogs() {
    const components = [];
    this.formioController.getFormCatalogs().subscribe(
      (data) => {
        const list = data as ClassificationType[];
        if (list.length > 0) {
          list.forEach((item) => {
            components.push({
              title: item.name,
              key: FormUtils.generateGuideIdFromTitle(item.name),
              icon: "fa fa-server",
              schema: {
                label: item.name,
                type: "select",
                catalog: item.id,
                dataSrc: "catalog",
                input: true,
                version: "201905",
              },
            });
          });
        }
        this.loadingCatalogs = false;
        console.log(components);
        this.allCatalogs = components;
      },
      (error) => this.showErrorMessageWithTitle("Error when loading Catalogs", error),
    );
  }

  public loadAllTags() {
    const components = [];
    this.tagControllerService.getServiceTagList(this.serviceId).subscribe(
      (data) => {
        const tempTags = [];
        _.forEach(data, (d) => {
          d.name = d.name.replace("License URL", "URL");
          tempTags.push(d);
        });
        this.moustaches = _.union(tempTags, this.moustaches);
        this.moustaches.sort((a, b) => {
          const nameA = this.returnFieldName(a).toLowerCase();
          const nameB = this.returnFieldName(b).toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
        });
        _.forEach(this.moustaches, (m) => {
          components.push({
            title: this.returnFieldName(m).replace("License URL", "URL"),
            key: m.key ? m.key : this.returnFieldName(m).replace(" ", "_"),
            icon: "fas fa-tag",
            type: "textfield",
            schema: {
              noOptions: false,
              type: "textfield",
              label: this.returnFieldName(m).replace("License URL", "URL"),
              title: this.returnFieldName(m),
              key: m.key ? m.key : this.returnFieldName(m).replace(" ", "_"),
              input: true,
            },
          });
        });
        this.loadingTags = false;
        this.allTags = components;
      },
      (error) => this.showErrorMessageWithTitle("Error when loading All tags", error),
    );
  }

  public returnFieldName(f: any) {
    if (f.name) {
      return f.name;
    }
    return f;
  }

  public loadAllFields() {
    const components = [];
    this.formControllerService.getServiceFieldsWithComponentHierarchy(this.serviceId).subscribe(
      (data) => {
        this.reloadFormArray(data.sort((a, b) => a.orderNumber - b.orderNumber ));
      },
      (error) => this.showErrorMessageWithTitle("Error when loading All Form Fields", error),
    );
  }

  public reloadFormArray(forms: ServiceField[]): void {
    this.allFields = [];
    this.addItems(forms, null);
    forms.forEach((field) => {
        let fieldGroup = null;
        fieldGroup = new FieldGroup();
        fieldGroup.level = 1;
        this.parseChildren(field, fieldGroup, field.form, 0);
        fieldGroup.items = field.items;
        fieldGroup.groupName = field.form;
        fieldGroup.name = field.form;
        fieldGroup.orderNumber = field.orderNumber;
        this.allFields.push(fieldGroup);
    });
    this.buildTree();
  }

  private addItems(components: any[], formName: string) {
    components.forEach((field) => {
        if (field.fullKey) {
            field.key = field.fullKey;
        }
        if (field.formType) {
            formName = field.formType;
        }
        field.form = formName;
        if (field.components) {
            field.leaf = false;
            field.items = field.components;
            this.addItems(field.items, formName);
       } else {
           field.leaf = true;
       }
    });
  }

  public parseChildren(field: ServiceField, fieldGroup: any, fieldGroupName: string, lvl: number) {
    const formField = this.createFormField(field, lvl ? Number(lvl) + 1 : 1);
    formField.formTitle = fieldGroupName;
    fieldGroup.fields.push(formField);
    field.isgroup = !field.leaf;
    field.level = lvl ? Number(lvl) + 1 : 1;
    if (field.isgroup) {
      // TODO: why name is null/undefined?
      if (field.name == null) {
        field.name = "";
      }
      field.name = field.name.replace(" form page", "");
      field.tree = field.name;
    }
    field.fieldName = field.name;
    field.typeclass = DataMappingHelpers.getFieldClass(field.type, field.multiple);
    field.field = formField;
    if (field.items) {
        field.items.forEach((item) => {
            this.parseChildren(item, fieldGroup, fieldGroupName, field.level);
        });
    }
  }

  public createFormField(field: ServiceField, lvl) {
    const formField = new FormField();
    const fieldKey = field.key.replace(/,/g, "-");
    formField.fieldKey = field.key;
    formField.formTitle = field.form;
    formField.type = field.type;
    formField.level = lvl;
    formField.orderNumber = field.orderNumber;
    formField.remoteType = this.setFieldRemoteType(field.type);
    if (field.name && field.name.toLocaleLowerCase() === "catalog") {
        field.name = "Value + internal key";
    }
    if (field.name && field.name.toLocaleLowerCase() === "key") {
        field.name = "Internal key";
        formField.type = "KEY";
        field.type = "KEY";
        // formField.remoteType = "KEY";
    }
    if (field.key && field.key.includes("CATALOG_EXTERNAL_KEY")) {
        formField.type = "KEY";
        field.type = "KEY";
        // formField.remoteType = "KEY";
    }
    if (field && field.name && field.name.startsWith("Role ")) {
        field.name = field.name.slice(4);
    }
    formField.fieldName = field.name;
    formField.label = field.name;
    formField.filter = field.filter;
    if (formField.type === "CLASSIFICATION" || formField.type === "catalog" || formField.type === "KEY") {
        formField.filter = null;
        field.filter = null;
    }
    // Hide content fields - to remove if needed
    if (field.type === "htmlelement") {
        formField.inputHidden = true;
        formField.outputHidden = true;
    }
    if (formField.label && formField.label.indexOf("value to key") !== -1) {
        formField.inputHidden = true;
        formField.outputHidden = true;
    }
    if (formField.fieldKey && formField.fieldKey.indexOf("VALUE_TO_KEY") !== -1) {
        formField.inputHidden = false;
        formField.outputHidden = false;
    } /* else {
        formField.inputHidden = this.bot.hiddenInputFormFields && JSON.parse(this.bot.hiddenInputFormFields).indexOf(fieldKey) > -1;
        formField.outputHidden = this.bot.hiddenOutputFormFields && JSON.parse(this.bot.hiddenOutputFormFields).indexOf(fieldKey) > -1;
    } */
    return formField;
  }

  public orderGroupItems(group) {
    if (group && group.items && group.items.length) {
        group.items.sort((a, b) => {
            return a.orderNumber < b.orderNumber;
        });
        group.items.forEach((i) => {
            this.orderGroupItems(i);
        });
    }
  }

  public setFieldRemoteType(type: string) {
    if (type) {
        switch (type.toLowerCase()) {
            case "date":
            case "datetime":
            case "date-time":
                return "date";
            case "numeric":
            case "number":
            case "decimal":
            case "integer":
                return "Number";
            case "checkbox":
            // case "selectboxes":
            //     return "checkbox";
            case "boolean":
                return "Boolean";
            case "document":
            case "fileupload":
            case "file":
            case "requirement":
            case "result":
            case "fileupload":
                return "file";
            case "classification":
            case "catalog":
                return "catalog";
            // case "fileupload":
                // return "fileupload";
            case "radio":
                return "radio";
            // case "checkbox":
            case "selectboxes":
            case "text":
            case "string":
            case "textfield":
            case "mycontent":
            default:
                return "string";
        }
    } else {
        return "Text";
    }
  }

  public checkIfGroupExists(items: FieldGroup[], groupName: string): FieldGroup {
    let matchFieldGroup = null;
    if (items) {
        items.some((item) => {
            if (item.isgroup && item.groupName === groupName) {
                matchFieldGroup = item;
                return true;
            }
            matchFieldGroup = this.checkIfGroupExists(item.items, groupName);
            if (matchFieldGroup !== null) {
                return true;
            }
        });
    }
    return matchFieldGroup;
  }

  public getGroups(fields, isgroup): any[] {
    const nodes = [];
    fields.forEach((field) => {
            nodes.push({
                isgroup: isgroup ? isgroup : false,
                leaf: !isgroup ? true : false,
                field,
                typeclass: DataMappingHelpers.getFieldClass(field.type),
                name: field.label,
                title: field.label,
            });
    });
    return nodes;
  }

  public searchInItems(items, searchedString) {
    return items.some((i) => {
        const group = i.isgroup ? this.searchInItems(i.items, searchedString) : false;
        const name = i.name ? i.name.toLowerCase().includes(searchedString) : false;
        const outputName = i.outputName ? i.outputName.toLowerCase().includes(searchedString) : false;
        if (group) {
            i.items = this.filterItems(i.items, searchedString);
        }
        return (group + name + outputName);
    });
}

  public filterItems(items, searchedString) {
    return items.filter((it) => {
        const group = it.isgroup ? this.searchInItems(it.items, searchedString) : false;
        const name = it.name ? it.name.toLowerCase().includes(searchedString) : false;
        const outputName = it.outputName ? it.outputName.toLowerCase().includes(searchedString) : false;
        if (group) {
            it.items = this.filterItems(it.items, searchedString);
        }
        return (group + name + outputName);
    });
  }

  public clearFilter() {
    this.filterText = "";
    this.fields = _.cloneDeep(this.allFields);
  }

  public searchInFields(value: any): void {
    this.searchStringFormatted = value.toLowerCase();
    if (value && value.length) {
        this.fields = this.filterItems(_.cloneDeep(this.allFields), this.searchStringFormatted);
    } else {
        this.fields = _.cloneDeep(this.allFields);
    }
  }

  public buildBranchesAndLeaves(branches: FieldGroup[]) {
      if (branches) {
          branches.forEach((branch) => {
              branch.items = branch.items ? branch.items : (branch.fields && this.getGroups(branch.fields, undefined));
              this.buildBranchesAndLeaves(branch.items);
          });
      }
  }

  public buildTree(): void {
    this.buildBranchesAndLeaves(this.allFields);
    this.fields = _.cloneDeep(this.allFields);
    console.log(this.fields);
    this.loadingFields = false;
  }

}
